import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// Components
import { ColorPicker } from 'components/ColorPicker';
import Accordion from 'components/Accordion';
// Utilities
import { isRequired } from 'utilities/validation';
// i18next
import { useTranslation } from 'react-i18next';

const SectionTheme:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors } } = useFormContext();

  return (
    <div react-scroll="theme">
      <Accordion label={t('labels.theme')} icon="theme">
        <div className="w-full">
          <div className="flex flex-wrap gap-4 sm:gap-8">
            <div className="mb-4">
              <Controller
                control={control} name="theme.primaryColor" rules={{ required: isRequired }}
                render={({ field: { value, onChange } }) => (
                  <ColorPicker
                    label={t('labels.primaryColor')}
                    value={value}
                    required={true}
                    error={Boolean(errors.theme?.primaryColor)}
                    errorText={errors.theme?.primaryColor ? errors.theme.primaryColor.message : ''}
                    onChange={onChange}
                  />
                )}
              />
            </div>
            <div className="mb-4">
              <Controller
                control={control} name="theme.primaryFontColor" rules={{ required: isRequired }}
                render={({ field: { value, onChange } }) => (
                  <ColorPicker
                    label={t('labels.primaryFontColor')}
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.theme?.primaryFontColor)}
                    errorText={errors.theme?.primaryFontColor ? errors.theme.primaryFontColor.message : ''}
                  />
                )}
              />
            </div>
          </div>

          <h2 className="text-xl font-bold text-white mb-2">
            {t('labels.actionButtonsColor')}
          </h2>
          <div className="flex flex-wrap gap-4">
            <div className="mb-4">
              <Controller
                control={control} name="theme.primaryButtonGradientStart" rules={{ required: isRequired }}
                render={({ field: { value, onChange } }) => (
                  <ColorPicker
                    label={t('labels.startColor')}
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.theme?.primaryButtonGradientStart)}
                    errorText={errors.theme?.primaryButtonGradientStart ? errors.theme.primaryButtonGradientStart.message : ''}
                  />
                )}
              />
            </div>
            <div className="mb-4">
              <Controller
                control={control} name="theme.primaryButtonGradientEnd" rules={{ required: isRequired }}
                render={({ field: { value, onChange } }) => (
                  <ColorPicker
                    label={t('labels.endColor')}
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.theme?.primaryButtonGradientEnd)}
                    errorText={errors.theme?.primaryButtonGradientEnd ? errors.theme.primaryButtonGradientEnd.message : ''}
                  />
                )}
              />
            </div>
            <div className="mb-4">
              <Controller
                control={control} name="theme.primaryButtonFontColor" rules={{ required: isRequired }}
                render={({ field: { value, onChange } }) => (
                  <ColorPicker
                    label={t('labels.fontColor')}
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.theme?.primaryButtonFontColor)}
                    errorText={errors.theme?.primaryButtonFontColor ? errors.theme.primaryButtonFontColor.message : ''}
                  />
                )}
              />
            </div>
          </div>
          <span className="block text-white text-xs font-light mb-4">{t('form.helperText.buttonsGradientColorsHint')}</span>
        </div>
      </Accordion>
    </div>
  )
}

export default SectionTheme;
